// NDBC adapter for the BuoySource contract. The observation parsing lives in
// ../ndbc.ts (unchanged); this file adds the catalog loader (activestations.xml)
// and the display metadata, wrapping both behind the shared interface.

import type { BuoyRef, BuoySource, BuoyStation } from "./types.js";
import { fetchBuoyObs } from "../ndbc.js";

/** Parse the NDBC activestations.xml catalog into plottable met stations. */
async function loadNdbcCatalog(): Promise<BuoyStation[]> {
  let text: string;
  try {
    const res = await fetch("/ndbc/activestations.xml");
    if (!res.ok) return [];
    text = await res.text();
  } catch {
    return [];
  }
  const xml = new DOMParser().parseFromString(text, "text/xml");
  const out: BuoyStation[] = [];
  for (const s of Array.from(xml.querySelectorAll("station"))) {
    if (s.getAttribute("met") !== "y") continue;
    const lat = Number(s.getAttribute("lat"));
    const lon = Number(s.getAttribute("lon"));
    const id = s.getAttribute("id") ?? "";
    if (id === "" || !Number.isFinite(lat) || !Number.isFinite(lon)) continue;
    out.push({ source: "ndbc", id, name: s.getAttribute("name") ?? id, lat, lon });
  }
  return out;
}

export const ndbcSource: BuoySource = {
  key: "ndbc",
  label: "NDBC",
  attribution: "NOAA NDBC",
  loadCatalog: loadNdbcCatalog,
  fetchObs: (id: string) => fetchBuoyObs(id),
  stationUrl: (id: string) =>
    `https://www.ndbc.noaa.gov/station_page.php?station=${encodeURIComponent(id)}`,
  pickLabel: (ref: BuoyRef) => `NDBC ${ref.id}`,
};
